import dataCache from './cache';

// Cache utility functions
export const cacheUtils = {
  // Clear all cache
  clearAll: () => {
    dataCache.clear();
    console.log('🗑️ Cache cleared');
  },

  // Clear cache for specific content type
  clearContentType: (contentType) => {
    const keys = Array.from(dataCache.cache.keys());
    keys.forEach(key => {
      if (key.startsWith(`${contentType}_`)) {
        dataCache.delete(key);
      }
    });
    console.log(`🗑️ Cache cleared for ${contentType}`);
  },

  // Clear cache for specific level
  clearLevel: (levelId) => {
    const keys = Array.from(dataCache.cache.keys());
    keys.forEach(key => {
      if (key.includes(`_${levelId}_`) || key.endsWith(`_${levelId}`)) {
        dataCache.delete(key);
      }
    });
    console.log(`🗑️ Cache cleared for level ${levelId}`);
  },

  // Force refresh specific cache key
  refresh: (key) => {
    dataCache.forceRefresh(key);
    console.log(`🔄 Cache refresh forced for ${key}`);
  },

  // Get cache stats
  getStats: () => {
    return {
      size: dataCache.size(),
      keys: Array.from(dataCache.cache.keys())
    };
  },

  // Preload common data for user
  preloadUserData: async (levelId) => {
    try {
      // Import services to avoid circular dependency
      const { getSubjects } = await import('../services/content');
      
      console.log('🚀 Preloading user data for level:', levelId);
      
      // Preload subjects
      await getSubjects(levelId);
      
      console.log('✅ User data preloaded');
    } catch (error) {
      console.error('❌ Failed to preload user data:', error);
    }
  }
};

export default cacheUtils;
